<template>
  <div class="navContainer">
    <nav class="container clearfix">
      <div class="fl">

        <router-link to="/" style="display: inline-block;">
          <img :src="url+infoData.siteLogo" alt="logo" />
        </router-link>
      </div>
      <div class="fr">
        <span>{{key=="/login"?"未注册交易所账号，点击":"已有交易所账号，点击"}}</span>
        <router-link :to="key=='/login'?'/register':'/login'">{{key=="/login"?"注册":"登录"}}</router-link>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      url: process.env.PATH_IMG,
    }
  },
  computed: {
    key() {
      return this.$route.path
    },
    ...mapState(['infoData']),
  },
  mounted(){

  }
}
</script>

<style lang="less" scoped>
    .navContainer{
      height: 146px;
      background-color: #fff;
      .container{
        height: 100%;
        .fr{
          font-size: 16px;
          padding: 44px 0;
          padding-top: 80px;
          color: #000;
          height: 100%;
          a{
            color:#a72226;
          }
        }
        .fl{
          display: flex;
          height: 100%;
          align-items: center;
          padding: 36px 0;
          a{
            display: inline-block;
          }
        }
      }

    }
</style>



// WEBPACK FOOTER //
// src/layout/components/PublicNav.vue